import { Type } from 'class-transformer';
import { BaseCriteriaDTO } from '@data/common/pagination/BaseCriteriaDTO';

export class PageCriteriaDTO extends BaseCriteriaDTO {

  @Type(() => Number)
  pageNumber: number;

  @Type(() => Number)
  pageSize: number;

  constructor(pageNumber = 0, pageSize = 10) {
    super();

    this.pageNumber = pageNumber;
    this.pageSize = pageSize;
  }
}
